var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChakraui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1930_22008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z",
    fill: "#4DB6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5648 30.4674H36.1361C35.8113 30.4674 35.6011 30.1184 35.7505 29.8241L44.488 12.6466C44.7138 12.2007 44.1492 11.7794 43.7966 12.1302L19.1301 36.762C18.8539 37.0387 19.0467 37.5164 19.4341 37.5164H35.6584C36.0093 37.5164 36.2143 37.9166 36.0145 38.2092L23.6361 56.3032C23.3408 56.7351 23.9036 57.2339 24.2857 56.8796L51.8584 31.2324C52.1502 30.961 51.9609 30.4674 51.5648 30.4674Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1930_22008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChakraui);
export default __webpack_public_path__ + "static/media/chakraui.97c4abbff05798e1752151ae06968667.svg";
export { ForwardRef as ReactComponent };